import React, { useCallback, useState } from 'react'
import { InfoIcon } from '@paytrace/pt-skel/Component/Icon'
import { If } from '@paytrace/pt-skel/Component'

interface InfoIconParam {
  message: string
  className?: string
  showRequiredSymbol?: boolean
  onHover?: boolean
}

export function InfoIconWithOptionalRequiredSymbol (props: InfoIconParam): React.ReactElement {
  const { message, className, showRequiredSymbol = false, onHover = false } = props
  const [showMessage, setShowMessage] = useState<boolean>(false)

  const handleClick = useCallback(() => {
    setShowMessage(true)

    setTimeout(() => {
      setShowMessage(false)
    }, 3000)
  }, [])

  const handleMouseEnter = useCallback(() => {
    setShowMessage(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setShowMessage(false)
  }, [])

  const formattedMessage = message.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))

  return (
    <>
      {showMessage && (
        <span className={!className ? 'hint' : className}>
          {formattedMessage}
        </span>
      )}
      <If is={onHover}>
        <span
          className="info-icon"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}>
          <InfoIcon />
        </span>
      </If>
      <If isNot={onHover}>
        <span className={'info-icon'} onClick={() => handleClick()}>
          <InfoIcon />
        </span>
      </If>
      {showRequiredSymbol && <span className='required-symbol-red'>*</span>}
    </>
  )
}
